/* eslint-disable react-hooks/exhaustive-deps */

import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  LANGUAGE,
  MODAL_BODY,
  CHAT_APP,
  QUESTION_ORDER,
  SESSION_STORAGE_KEYS,
} from "../../constants/constant";
import {
  clearChatSlice,
  sendSurveyDetails,
  clearSurveyDetails,
  exitChat,
  setGetPollIntervalId,
} from "../../redux/slices/ChatSlice/chatSlice";
import { clearFormSlice } from "../../redux/slices/FormSlice/formSlice";
import FormButton from "../common/FormButton";
import FeedbackOptionView from "./FeedbackOptionView";
import {
  getCurrentDateTime,
  getLanguage,
  getQuestionOptions,
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from "../../util/UtilMethods";

const FeedbackForm = (props) => {
  const { questionIndex, setQuestionIndex, setModalBody } = props;
  const { participantId, intervalId } = useSelector((state) => state.chat);

  const questionOrder = Number(
    getSessionStorage(SESSION_STORAGE_KEYS.QUESTION_INDEX)
  );
  const [selectedValue, setSelectedValue] = useState({
    difficulty: "",
    satisfaction: "",
    rating: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    const surveyData = JSON.parse(
      getSessionStorage(SESSION_STORAGE_KEYS.SURVEY_DETAILS)
    );

    if (surveyData && Object.keys(surveyData).length > 0) {
      setSelectedValue(surveyData);
    }

    if (questionOrder !== 0) {
      setQuestionIndex(questionOrder);
    }
  }, []);

  useEffect(() => {
    setSessionStorage(
      SESSION_STORAGE_KEYS.SURVEY_DETAILS,
      JSON.stringify(selectedValue)
    );
  }, [selectedValue]);

  useEffect(() => {
    setSessionStorage(SESSION_STORAGE_KEYS.QUESTION_INDEX, questionIndex);
  }, [questionIndex]);

  const { surveyDetails, receiveMessageList } = useSelector(
    (state) => state.chat
  );
  const { userData } = useSelector((state) => state.form);

  //useEffect to clear the redux state and session storage
  useEffect(() => {
    if (Object.keys(surveyDetails).length > 0) {
      dispatch(clearFormSlice());
      dispatch(clearChatSlice());
      setModalBody(MODAL_BODY.FORM);
      dispatch(clearSurveyDetails());
    }
  }, [surveyDetails]);

  //OnChange called when select any option
  const onChangeOption = (event) => {
    setSelectedValue({
      ...selectedValue,
      [event.target.name]: event.target.value,
    });
  };

  //This method will call post API for send survey data
  const handleCloseSurvey = () => {

  const lastMessage = receiveMessageList?.length > 0 ? receiveMessageList[receiveMessageList.length - 1] : null;

  const ChatOn = lastMessage
      ? `${new Date().toISOString().split("T")[0]} ${lastMessage.time}:00`
      : new Date().toISOString();  // Fallback in case there’s no last message
      
      let  agentName ="";
      if(receiveMessageList !== undefined ){     
        agentName = receiveMessageList.find(item => item.participantType === "Agent")?.name;
      }
      
      const requestBody = {
      AgentFullName: agentName,
      UserName: userData.fullName,
      Channel: CHAT_APP.CHAT,
      MobileNumber: `${userData.contactNo}`,
      EmailId: userData.emailAddress,
      ChatOn: ChatOn,
      SurveyOn: getCurrentDateTime(),
      CustomerEffortScore: selectedValue.difficulty,
      OverallSatisfactionScore: selectedValue.satisfaction,
      NetPromoterScore: selectedValue.rating,
      Custom1: LANGUAGE.ENGLISH === getLanguage() ? LANGUAGE.EN : LANGUAGE.AR,
      Custom2: CHAT_APP.TWO,
      Custom3: "",
      Custom4: "",
      Custom5: "",
    };
    dispatch(sendSurveyDetails(requestBody));
    removeSessionStorage(SESSION_STORAGE_KEYS.QUESTION_INDEX);

        handleEndSession();

  };

 const handleEndSession = () => {
        dispatch(exitChat(participantId));
        dispatch(setGetPollIntervalId(""));
        clearInterval(intervalId);
        dispatch(clearFormSlice());
        dispatch(clearChatSlice());
        setModalBody(MODAL_BODY.FORM);
      };

  //Render the question view
  const getFeedbackActiveView = () => {
    switch (questionIndex) {
      case QUESTION_ORDER.OVERALL_EFFORT:
        return (
          <FeedbackOptionView
            questionText={t("overall_effort")}
            inputName="difficulty"
            className="mr-1 pl-1"
            inputType="radio"
            inputValue={selectedValue.difficulty}
            onChangeOption={onChangeOption}
            optionText={getQuestionOptions(t)}
          />
        );

      case QUESTION_ORDER.OVERALL_SATISFACTION:
        return (
          <FeedbackOptionView
            questionText={t("overall_statisfaction")}
            inputName="satisfaction"
            className="mr-1 pl-1"
            inputType="radio"
            inputValue={selectedValue.satisfaction}
            onChangeOption={onChangeOption}
            optionText={getQuestionOptions(t)}
          />
        );

      case QUESTION_ORDER.LIKE_TO_SUGGEST:
        return (
          <FeedbackOptionView
            questionText={t("like_to_suggest")}
            inputName="rating"
            className="mr-1 pl-1"
            inputType="radio"
            inputValue={selectedValue.rating}
            onChangeOption={onChangeOption}
            optionText={getQuestionOptions(t)}
          />
        );

      default:
        return <></>;
    }
  };

  const checkNextDisable = () => {
    return !!(
      (QUESTION_ORDER.OVERALL_EFFORT === questionIndex &&
        selectedValue.difficulty === "") ||
      (QUESTION_ORDER.OVERALL_SATISFACTION === questionIndex &&
        selectedValue.satisfaction === "")
    );
  };

  return (
    <div className="survey-form">
      {getFeedbackActiveView()}

      {QUESTION_ORDER.LIKE_TO_SUGGEST === questionIndex ? (
        <FormButton
          className="btn xl blue btn-danger bg-danger mt-4"
          type="button"
          disabled={selectedValue.rating === ""}
          onClick={() => handleCloseSurvey()}
          buttonText={t("close")}
        />
      ) : (
        <FormButton
          className="btn xl blue"
          type="button"
          disabled={checkNextDisable()}
          onClick={() => setQuestionIndex(questionIndex + 1)}
          buttonText={t("next")}
        />
      )}
    </div>
  );
};

export default FeedbackForm;
